import React from 'react'
import Spinner from './Spinner'

export default function SubmitButton(props) {
  const { children, className, isLoading, ...rest } = props

  return (
    <button
      type="submit"
      {...rest}
      disabled={isLoading}
      className={['flex items-center justify-center', className]}
      >
      {isLoading && (
        <Spinner color="white" height="1.2em" className="absolute" />
      )}
      <span className={[isLoading && 'opacity-0']}>
        {children}
      </span>
    </button>
  )
}
